import axios from './axios'
import qs from 'qs';

let amazonBastUrl = '/api/amazonCommodity/';
/**
 *
 *
 */
export default {
  // 行业情报列表
  list(data) {
    // return axios.post(amazonBastUrl + 'list', qs.stringify(data));
    // debugger
    return axios.get(amazonBastUrl + 'list', {
      params: data
    });
  },

  //添加asin
  editCompetitionAsin(data) {
    return axios.post(amazonBastUrl + 'editCompetitionAsin', qs.stringify(data));
  },



  // 删除竞品
  deleteCompetitionAsin(data) {
    return axios.post(amazonBastUrl + 'deleteCompetitionAsin', qs.stringify(data));
  },

  // 编辑备注
  editRemark(data) {
    return axios.post(amazonBastUrl + 'editRemark', qs.stringify(data));
  },

  // 加星
  changeStar(data) {
    return axios.post(amazonBastUrl + 'changeStar', qs.stringify(data));
  },

  //获取搜索词历史记录
  getSearchKeywordHistoryListUrl(data) {
    return axios.post(amazonBastUrl + 'getSearchKeywordHistoryList', qs.stringify(data));
  },
  /**
   * 获取父商品对应的竞品信息
   */
  getCompetitionByAsin(data) {
    // return axios.post(amazonBastUrl + 'list', qs.stringify(data));
    // debugger
    return axios.get(amazonBastUrl + 'parentCompetitions', {
      params: data
    });
  },

}
